// Automatically switch Elementor Tabs on page load.
window.addEventListener("load", function () {
    const hash_parts = (location.hash)
        ? /^#tab-(.+)-(\d+)$/.exec(location.hash)
        : null;

    if (!hash_parts) {
        return;
    }

    const tabs_id = hash_parts[1];
    const tab_index = hash_parts[2];

    const $tabs_widget = document.querySelector(".elementor-widget-n-tabs#" + tabs_id);
    const $tabs_button = ($tabs_widget)
        ? $tabs_widget.querySelector("button.e-n-tab-title[data-tab-index='" + tab_index + "']")
        : null;

    if (!$tabs_button) {
        return;
    }
    
    $tabs_button.dispatchEvent(new CustomEvent("click", {
        target: $tabs_button
    }));
});
